<template>
  <nav class="mobile-portrait-nav">
    <toggle-router-link
      :toRouteName="'bills-open'"
      :className="navClass(['bills-open', 'bills-detail'])"
      @click.native="closeMenuSide"
      v-translate
    >Bills</toggle-router-link>

    <toggle-router-link
      :toRouteName="'order'"
      :className="navClass([
        'order',
        'new-order',
        'change-order',
        'choose-cust',
        'add-note',
        'add-customer',
        'order-level',
        'set-commission',
        'variable-price',
      ])"
      @click.native="closeMenuSide"
      v-translate
    >Order</toggle-router-link>

    <toggle-router-link
      v-if="isCashier"
      :toRouteName="'pay'"
      :className="navClass(['pay', 'pay-cash', 'swipe-card', 'do-payment', 'pay-commission'])"
      :redirectCondition="[can('closeBill'), isBill('open'), !getLastNormalItem]"
      :errorMessage="[
        $gettext('Permission denied'),
        $gettext('Please get an open bill'),
        $gettext('Please print bill first')
      ]"
      @click.native="closeMenuSide"
      v-translate
    >Pay</toggle-router-link>

    <button
      v-else
      type="button"
      class="mobile-portrait-nav__btn is-disabled"
      disabled
      v-translate
    >Pay</button>

    <button
      type="button"
      class="mobile-portrait-nav__btn"
      :class="{ 'is-active': isMenuSideVisible || isMoreContextRoute }"
      @click="toggleMenu"
      v-translate
    >More</button>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ToggleRouterLink from '@/components/ToggleRouterLink.vue';
import { ON_INPUT_PAD_BLUR, TOGGLE_MENU_SIDE } from '@/store/mutation-types';

export default {
  name: 'MobilePortraitNav',
  components: {
    ToggleRouterLink,
  },
  computed: {
    ...mapState({
      isMenuSideVisible: state => state.toggle.isMenuSideVisible,
    }),
    ...mapGetters([
      'isBill',
      'getLastNormalItem',
    ]),
    isMoreContextRoute() {
      const routeName = this.$route && this.$route.name ? this.$route.name : '';
      return [
        'bills-reprint',
        'staffs',
        'cash-calc',
        'stock-delivery',
        'add-staff',
        'split-bill',
        'merge-bill',
        'void-bill',
      ].includes(routeName);
    },
  },
  watch: {
    '$route.name'() {
      this.closeMenuSide();
    },
  },
  methods: {
    navClass(routeNames) {
      const routeName = this.$route && this.$route.name ? this.$route.name : '';
      const activeClass = routeNames.includes(routeName) ? ' is-active' : '';
      return `mobile-portrait-nav__btn${activeClass}`;
    },
    toggleMenu() {
      if (this.isMoreContextRoute && !this.isMenuSideVisible) {
        this.$router.push({ name: 'order' });
        return;
      }
      this.$store.commit(TOGGLE_MENU_SIDE);
    },
    closeMenuSide() {
      this.$store.commit(ON_INPUT_PAD_BLUR, true);
      this.$store.commit(TOGGLE_MENU_SIDE, false);
    },
  },
};
</script>
